import { RedirectRoute } from '../Routing/types';
const redirects: RedirectRoute[] = [
  {
    path: '/',
    redirectTo: '/meals/cookbook',
  },
];

export default redirects;
